import type { Notification } from 'src/dto'

export type NotificationMessagePart = { text: string; emphasized?: boolean }

// 서버 message 는 구버전 클라이언트 폴백용 완성 문장이라 강조 위치를 알 수 없다.
// 이름 필드가 함께 오는 알림만 FE 가 문장을 조립해 학생명·학습지명을 강조한다
export const getNotificationMessageParts = (
  payload: Notification['payload'],
  message: Notification['message'],
): NotificationMessagePart[] => {
  if (
    payload?.eventType === 'STUDENT_WORKSHEET_SUBMIT' &&
    payload.studentName &&
    payload.worksheetTitle
  ) {
    return [
      { text: payload.studentName, emphasized: true },
      { text: ' 학생이 학습지 제출을 완료했습니다.\n' },
      { text: payload.worksheetTitle, emphasized: true },
      { text: ' 학습지를 지금 바로 확인해보세요!' },
    ]
  }

  return [{ text: message }]
}
